import { Card } from "flowbite-react";
import { ButtonLoginRegister } from "../buttons/ButtonLoginRegister";
import "./CardLoginAndRegister.css"

interface ICardLoginAndRegister {
  handleSwitchForm: () => void;
  isShowFormLogin: boolean;
  setIsShowFormLogin: React.Dispatch<React.SetStateAction<boolean>>
}

export function CardLoginAndRegister({ handleSwitchForm, isShowFormLogin }: ICardLoginAndRegister) {
  const actions = { handleSwitchForm };

  return (
    <Card id="cardLoginRegister" className="bg-white rounded-2xl border-none h-[40%] w-[40%] shadow-2xl flex justify-center" horizontal>
      <ButtonLoginRegister actions={actions} mode={isShowFormLogin ? `S'inscrire ?` : `Se connecter ?`} />
      <div id="div-logo-card" className="flex justify-center">
        <img id="img-logo-card" src="/logo-cemade.png" alt="Bannière de l'application" />
      </div>
    </Card>
  );
}